import { apiClient } from './client'

export interface Department {
  id: string
  org_id: string
  name: string
  code?: string | null
  description?: string | null
  head_user_id?: string | null
  head_user_name?: string | null
  is_active: boolean
  member_count: number
  created_at: string
  updated_at: string
}

export interface DepartmentInput {
  name: string
  code?: string | null
  description?: string | null
  head_user_id?: string | null
  is_active?: boolean
}

export interface Designation {
  id: string
  org_id: string
  title: string
  level?: string | null
  description?: string | null
  is_active: boolean
  member_count: number
  created_at: string
  updated_at: string
}

export interface DesignationInput {
  title: string
  level?: string | null
  description?: string | null
  is_active?: boolean
}

// Departments
export async function listDepartments(params: { search?: string; is_active?: boolean } = {}): Promise<Department[]> {
  const response = await apiClient.get<Department[]>('/departments', { params })
  return response.data
}
export async function createDepartment(data: DepartmentInput): Promise<Department> {
  const response = await apiClient.post<Department>('/departments', data)
  return response.data
}
export async function updateDepartment(id: string, data: Partial<DepartmentInput>): Promise<Department> {
  const response = await apiClient.put<Department>(`/departments/${id}`, data)
  return response.data
}
export async function deleteDepartment(id: string): Promise<void> {
  await apiClient.delete(`/departments/${id}`)
}

// Designations
export async function listDesignations(params: { search?: string; is_active?: boolean } = {}): Promise<Designation[]> {
  const response = await apiClient.get<Designation[]>('/designations', { params })
  return response.data
}
export async function createDesignation(data: DesignationInput): Promise<Designation> {
  const response = await apiClient.post<Designation>('/designations', data)
  return response.data
}
export async function updateDesignation(id: string, data: Partial<DesignationInput>): Promise<Designation> {
  const response = await apiClient.put<Designation>(`/designations/${id}`, data)
  return response.data
}
export async function deleteDesignation(id: string): Promise<void> {
  await apiClient.delete(`/designations/${id}`)
}
